"use strict";

var header = document.querySelector('.js-header');

function showMenu() {
  header.classList.toggle('is-open');
}